import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import {
    FacebookFilled,
    ViberFilled,
    YoutubeFilled,
    TelegramFilled,
} from "@assets";
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  position: absolute;
  top: 0;

  display: flex;
  gap: 12px;

  width: 100%;
  background-color: #212224;

>div {
    flex: 1;
}
`;

const Socials = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 12px 0;
`;

const BoldText = styled.div`
  color:  #F9F9F9;
  font-size: 12px;
  font-style: normal;
  font-weight: 200;
  line-height: normal;
`;

const SocialBox = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 7px;

  svg {
      max-width: 30px;
      height: auto;
      max-height: 30px;
  }
`;

const SocialsBox = () => {
    const { t } = useTranslation();
    const { settings: { social_links } } = useSelector(state => state.app);

    const Link = ({ url, children }) => (
        <a href={url} target="_blank" rel="noreferrer noopen">
            {children}
        </a>
    );

    return (
        <Container>
            <Socials>
                <BoldText>
                    {t("home.appDownloadSubTitle1")} :
                </BoldText>
                <SocialBox>
                    <Link url={social_links?.fb_link}>
                        <FacebookFilled />
                    </Link>
                    <Link url={social_links?.viber_link}>
                        <ViberFilled />
                    </Link>
                    <Link url={social_links?.telegram_link}>
                        <TelegramFilled />
                    </Link>
                    <Link url={social_links?.youtube_link}>
                        <YoutubeFilled />
                    </Link>
                </SocialBox>
            </Socials>
            
        </Container>
    );
}

export default SocialsBox;